<style lang="less">
    @import "../vars";

    .component-page_bg {
        position: fixed;
        z-index: -1;
        background: #F9F9F9;
        top: 0;
        width: 100%;
        height: 100%;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
    }
</style>

<template>
    <div class="component-page_bg">

    </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {},
    //计算属性
    computed: {},
    //组件
    components: {},
    //自定义方法
    methods: {},
  }
</script>
